// libs/common/src/shared/validators/pagination.ts
import { z } from 'zod';

export interface CursorPosition {
    sortValue: string;
    id: string;
}

export const createCursorPaginationSchema = <TSortKey extends string>(
    sortByEnum: [TSortKey, ...TSortKey[]],
    defaultSort: TSortKey = 'createdAt' as TSortKey
) => z.object({
    limit: z.number().int().min(1).max(100).default(10),
    search: z.string().optional(),
    // Cast is safe here because `defaultSort` is always one of the `sortByEnum` entries
    sortBy: z.enum(sortByEnum).default(defaultSort as any),
    sortOrder: z.enum(['asc', 'desc']).default('desc'),
    cursor: z.object({
        sortValue: z.string(),
        id: z.string(),
    }).optional(),
});

export type CursorPaginationInput<TSortKey extends string> = z.infer<
    ReturnType<typeof createCursorPaginationSchema<TSortKey>>
>;